<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div :class="$style.top" :libraryId="libraryId">
            <div>
<!--                <el-row>-->
<!--                    <el-col :span="20"><div align="left" style="padding-top: 8px; color: cornflowerblue">-->
<!--                        <span style="color: black; font-size: 14px">{{product_num}}个产品  &nbsp; 终端辖区{{terminal_num}}个 &nbsp; | &nbsp;-->
<!--                            销售团队{{sales_num}}人</span>-->

<!--                    </div></el-col>-->
<!--                </el-row>-->
                <el-row style="margin-top: 20px">
                    <el-col :span="20">
                        <el-button :disabled="!data.territory_id" icon="el-icon-plus" type="success" size="small"
                                   @click="saveManger" v-if="save_onoff">
                            添加管理人员
                        </el-button>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 15px">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="管理人员">
                            <el-row style="margin-bottom: 10px;margin-left: 5px;">
                                <el-col style="width: calc(100% - 165px)">
                                    <el-input v-model="inputValue" placeholder="请输入内容" size="mini"></el-input>
                                </el-col >
                                <el-col  style="width: 165px;">
                                    <el-button type="danger" @click="resetPeople" size="mini" style="float: right;margin-right: 20px;">重置</el-button>
                                    <el-button type="primary" @click="getPeople" size="mini" style="float: right;margin-right: 20px;">查询</el-button>
                                </el-col>
                            </el-row>

                            <BoxItem style="float: left;margin: 5px" :info="item"
                                     @getPeople="getPeople"
                                     :options="options" :class="$style.item" v-for="item in lists" :key="item.userId"/>
                        </el-tab-pane>
                    </el-tabs>
                </el-row>
            </div>
        </div>

        <el-dialog title="" :visible.sync="modelManger" :show-close="false" id="addPeopleDialog">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:10px 0px">
                <span style="color: #3998F7;font-size: 22px;padding-top: 5px">添加管理人员</span>
                <span>
                <el-button @click="inputSaveJuManger" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="closeManger" size="small">取消</el-button>
                </span>
            </div>
            <el-form class="formSave" ref="addPeopleForm" :model="formManger" style="width: 80%;margin: auto" label-position="left" hide-required-asterisk>
                <el-form-item label="所属辖区" label-width="100px">
                    <el-row>
                        <el-col style="color: #3998f7;" :push="2">
                            {{formManger.territory_name}}&nbsp;&nbsp;{{formManger.territory_code}}
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="管理人员"  label-width="100px" class="addPeople_star"
                              prop="mangerArray" :rules="[{ required: true, message: '管理人员不能为空'},]">
                    <el-row>
                        <el-col :span="22" :push="2">
                            <!--                            <el-select @emove-tag="emoveTag" style="width: 100%"-->
                            <!--                                       v-model="formManger.mangerArray"-->
                            <!--                                       multiple-->
                            <!--                                       placeholder="请选择"-->
                            <!--                                       @change="">-->
                            <!--                                <el-option-->
                            <!--                                        v-for="item,index in addManger"-->
                            <!--                                        :key="item"-->
                            <!--                                        :label="item.user_name"-->
                            <!--                                        :value="item.user_id">-->
                            <!--                                </el-option>-->
                            <!--                            </el-select>-->

                            <el-cascader
                                    style="width: 100%"
                                    v-model="formManger.mangerArray"
                                    @change="changeEveryOne"
                                    :filterable="true"
                                    :show-all-levels="false"
                                    :options="addManger"
                                    :props="cascader_props"
                                    clearable></el-cascader>
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../APIService/http'
    import BoxItem from './boxItemactive'
    import {bus} from '../../router/index'
    export default {
        name: "index",
        data(){
            return {
                loading:false,
                quitReasons:[],
                options:[],
                inputValue:'',
                lists:[],
                data:'',
                sales_num:0,
                terminal_num:0,
                product_num:0,
                removeTrue:'',
                modelManger:false,
                formManger:{
                    territory_name:'',
                    territory_code:'',
                    territory_id:'',
                    mangerArray:[],
                },
                cascader_props:{
                    checkStrictly: true,
                    value : "ou_id",
                    label : "label",
                    disabled : "disabled",
                    emitPath:false,
                    multiple: true
                },
                addManger:[],
                save_onoff :true,
            }
        },
        components:{
            BoxItem
        },
        methods: {
            async resetPeople(){
                this.inputValue = ''
                this.loading = true;
                let data = this.$store.getters.getDataInfo;
                data.tenant_id = this.$store.getters.getUser.tenant_id;
                data.last_name = this.inputValue;

                // console.log(data)
                await http.post("/wapi/JurActive/jurisdictionPeople", data).then((res) => {
                    this.$nextTick(function () {
                        this.lists = res.data;
                        this.loading = false;
                    });
                });
            },
            async getPeople(){

                this.loading = true
                let data = this.$store.getters.getDataInfo
                data.tenant_id=this.$store.getters.getUser.tenant_id
                data.last_name = this.inputValue.trim()
                // console.log(data)
                await http.post('/wapi/JurActive/jurisdictionPeople',data).then(res=>{
                    this.$nextTick(function () {
                        this.lists = res.data
                        this.loading = false
                    })
                })
            },
            childByvalue(val){
                this.removeTrue = val
            },
            inputSaveJuManger() {
                this.$refs['addPeopleForm'].validate((valid) => {
                    if (valid) {
                        this.saveJuManger()
                    } else {
                        // Message.error('保存失败')
                        return false;
                    }
                });
            },
            closeManger(){
                this.modelManger = false
                this.$refs['addPeopleForm'].resetFields();
            },
            saveManger(){
                this.modelManger = true
                if (this.data.territory_code){
                    this.formManger.territory_code ="("+ this.data.territory_code+")"
                }

                this.formManger.territory_id = this.data.territory_id
                this.formManger.territory_name = this.data.territory_name
                this.formManger.mangerArray=[]
            },
            async getMangerList(){
                try {
                    let data ={}
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id

                    await http.post('/wapi/JurActive/getManger',data).then(res=>{
                        if (res.success == true){
                            this.addManger = res.data
                        }
                    })
                }catch (e) {

                }
            },
            async saveJuManger(){
                try {
                    let data = this.formManger
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    data.month = this.$store.getters.getDataInfo.month

                    // console.log(this.$store.getters.getDataInfo)
                    await http.post('/wapi/JurActive/saveManger',data).then(res=>{
                        if (res.success == true){
                            this.modelManger = false
                            this.$message({
                                type: 'success',
                                message: '添加成功'
                            });
                            let salseList = []
                            for (let i =0; i<data.mangerArray.length;i++){
                                let j={
                                    manager_id:data.mangerArray[i]
                                }
                                salseList.push(j)
                            }
                            // console.log(salseList)
                            let obj = this.$store.getters.getDataInfo
                            obj.salseList = obj.salseList.concat(salseList)
                            // this.sales_num = obj.salseList.length
                            this.$store.commit('setDataInfo',obj.salseList)
                            // console.log(obj)
                            // console.log(this.$store.getters.getDataInfo)
                            bus.$emit('changeList',new Date())
                            this.getPeople()
                        }
                    })
                }catch (e) {

                }
            }
        },
        created(){

        },
        mounted() {
            this.save_onoff = this.$store.getters.getDataInfo.save_onoff
            this.data = this.$store.getters.getDataInfo
            // console.log(this.$store.getters.getDataInfo)
            this.getPeople()
            this.getMangerList()
            this.sales_num = this.data.sales_num ? this.data.sales_num : 0
            // console.log(this.sales_num)
            this.terminal_num = this.data.terminal_num ? this.data.terminal_num :0
            this.product_num = this.data.product_num ? this.data.product_num :0
        },
        computed: {
            peopleLength(){
                // bus.$on('getPeopleLength',(e)=>{
                //     this.sales_num = e
                // })
                // return this.sales_num
            }
        },
        watch: {
            // $route (to,from){
            //     this.$nextTick(function () {
            //         console.log(this.$route)
            //         this.data=JSON.parse(this.$route)
            //         this.getPeople()
            //     })
            // },
            removeTrue(i,j){
                // console.log(i)
                // console.log(j)
            },
            peopleLength(val,oldval){
            }
        },
        beforeDestroy() {

        }
    }
</script>

<style lang="scss" module>
    .container {
        .top {

        }
    }
</style>
<style scopeds>
    #addPeopleDialog .el-dialog__header {
        padding: 10px 20px 10px;
    }
    #addPeopleDialog .el-dialog__body {
        padding: 10px 20px;
    }
    #addPeopleDialog .el-form-item__label {
        font-size: 16px;
        color: black;
    }
    #addPeopleDialog .addPeople_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
    #addPeopleDialog .el-form-item__error{
        left: 8.3%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/jurisdiction/indexactivetow.vue